import slick from 'slick-slider';

jQuery(document).ready(function ($) {

//----------------------------------------------Sliders-----------------------------------//
    $('.winners-list').slick({
        slidesToShow: 2,
        dots: false,
        infinite: true,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2
                }
            },
        ]
    });
});